<app-document-countries
  [name]="'Договор публичной оферты аренды электроснегокатов'"
  [countries]="countries"
></app-document-countries>
